import { useLocation, useNavigate } from "react-router-dom";
import { useCallback } from "react";

const useBackButton = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const showBackButton = location.pathname !== "/home";

  const handleBackClick = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return {
    showBackButton,
    handleBackClick,
  };
};

export default useBackButton;
